<template>
    <div id="ArchiveComponent">
        <b-row v-if="!hideFilters">
            <b-col class="pl-3">
                <b-form-group
                    id="start-date-input-group"
                    :label="$t('message.first')"
                    class="custom-input mb-0"
                    label-for="start-date-input"
                    label-sr-only
                >
                    <datetime
                        v-model="startDate"
                        :max-datetime="maxDate"
                        :min-datetime="lastFiveYear"
                        :phrases="phrases"
                        :placeholder="$t('message.startDate')"
                        auto
                        input-class="form-control rounded-0"
                        input-id="start-date-input"
                        type="datetime"
                    />
                </b-form-group>
            </b-col>
            <b-col class="pl-3">
                <b-form-group
                    id="end-date-input-group"
                    :label="$t('message.last')"
                    class="custom-input mb-0"
                    label-for="end-date-input"
                    label-sr-only
                >
                    <datetime
                        v-model="endDate"
                        :max-datetime="maxDate"
                        :min-datetime="lastFiveYear"
                        :phrases="phrases"
                        :placeholder="$t('message.endDate')"
                        auto
                        input-class="form-control rounded-0"
                        input-id="end-date-input"
                        type="datetime"
                    />
                </b-form-group>
            </b-col>
            <b-col class="pl-3">
                <b-form-group
                    id="query-input-group"
                    :label="$t('message.query')"
                    class="custom-input mb-0"
                    label-for="query-input"
                    label-sr-only
                >
                    <b-form-input id="query-input" v-model="query" :placeholder="$t('message.query')" name="query" />
                </b-form-group>
            </b-col>
            <b-col class="pl-3">
                <b-form-group
                    id="query-input-group2"
                    :label="$t('message.query')"
                    class="custom-input mb-0"
                    label-for="query-input"
                    label-sr-only
                >
                    <b-form-select v-model="selectedUser" class="mb-3">
                        <option :value="null">
                            {{ $t("message.allUsers") }}
                        </option>
                        <option v-for="item in usersFilter.data" :key="item._id" :value="item._id">
                            {{ item.name }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col class="pl-3">
                <div class="custom-input">
                    <a-rate v-model="point" :allow-clear="true" />
                </div>
            </b-col>
        </b-row>
        <b-row class="mb-3">
            <b-col :class="{ 'col-5': !wideScreen, 'col-4': wideScreen }">
                <div id="conversation-list" class="scrollable" v-on:scroll="handleScroll">
                    <EmptyFilterResult v-if="!tableData.length && !isBusy" :clear-filters="resetFilters" />
                    <b-table id="visitor-list-table" :fields="fields" :items="tableData" :tbody-tr-class="rowClass">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <template v-slot:cell(actions)="data">
                            <div class="info" @click="view(data.item._id)">
                                <div class="custom-card userInfo">
                                    <b>{{ data.item.fullname }}</b>
                                    <b>{{ data.item.email }}</b>
                                    <b>{{ data.item.user ? data.item.user.name : "-" }}</b>
                                </div>
                                <div class="custom-card back chatMeta">
                                    <b>{{ data.item.createdDate | date("D/M/YY HH:m:s") }}</b>
                                    <b>
                                        <a-rate :default-value="data.item.point || 0" disabled size="12" />
                                    </b>
                                </div>
                            </div>
                        </template>
                    </b-table>
                    <div v-if="isBusy" class="text-center text-info my-3">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                    <div v-if="!tableData.length" class="text-center text-info my-3">
                        {{ $t("message.chatNotFound") }}
                    </div>
                </div>
            </b-col>
            <b-col :class="{ 'col-7': !wideScreen, 'col-5': wideScreen }" class="pl-3">
                <div class="scrollable" style="overflow: hidden">
                    <div v-if="selectedHistory.id && !wideScreen" class="userMetaInfo bg-white">
                        <b-col style="margin: 10px">
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.fullName") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ selectedHistory.conversation.fullname }}
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.email") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ selectedHistory.conversation.email }}
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.subject") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ getTicketSubject(selectedHistory) }}
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.representative") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ $_.get(selectedHistory, "conversation.user.name", "") || "" }}
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="userInfo">
                                    <div class="userInfo first">
                                        {{ $t("message.country") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{ $_.get(selectedHistory, "conversation.visitor.country", "N/A") || "N/A" }}
                                    </div>
                                </div>

                                <div class="userInfo pl-3">
                                    <div class="userInfo first">
                                        {{ $t("message.language") }}
                                    </div>
                                    <div class="userInfo sec">
                                        {{ selectedHistory.conversation.languageCode }}
                                    </div>
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.osAndBrowser") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ $_.get(selectedHistory, "conversation.visitor.os", "N/A") || "N/A" }}
                                    {{ $_.get(selectedHistory, "conversation.visitor.browser", "N/A") || "N/A" }}
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">IP</div>
                                <div class="userInfo sec">
                                    {{ $_.get(selectedHistory, "conversation.visitor.ipAddress", "N/A") || "N/A" }}
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.chatId") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ selectedHistory.conversation._id }}
                                </div>
                            </div>
                            <div class="userInfo">
                                <div class="userInfo first">
                                    {{ $t("message.customerClientVersion") }}
                                </div>
                                <div class="userInfo sec">
                                    {{ $_.get(selectedHistory, "conversation.visitor.version.versionStr") || "N/A" }}
                                </div>
                            </div>
                        </b-col>
                        <b-row>
                            <b-col>
                                <h5 class="text-center pointer text-info my-2">
                                    {{ $t("message.userInfo") }}
                                    <md-icon class="text-info">expand_more</md-icon>
                                </h5>
                            </b-col>
                        </b-row>
                    </div>
                    <MessageList
                        v-if="IsMessageInChat"
                        :always-scroll-to-bottom="false"
                        :contextMenuVisable="false"
                        :colors="colors"
                        :messages="
                            $_.get(selectedHistory, 'conversation.conversation.startedWithChatBot', false) || isArchive
                                ? getMessages()
                                : getOfflineMessages(this.selectedHistory.conversation)
                        "
                        :participants="getParticipants()"
                        :scroll-top="true"
                        :is-whatsapp="!!$_.get(selectedHistory.conversation, 'whatsappNumber')"
                    />
                    <div v-else class="bg-light border px-3 py-1 px-3 text-center">
                        {{ $t("message.noMessageInChat") }}
                    </div>
                    <div v-if="isLoading" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </div>
            </b-col>
            <b-col v-if="wideScreen" id="information-list2" class="col-3 bg-white">
                <div class="headtitle">{{ $t("message.userInfo") }}</div>
                <div v-if="selectedHistory.id">
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.fullName") }}
                        </div>
                        <div class="userInfo sec">
                            {{ selectedHistory.conversation.fullname }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.email") }}
                        </div>
                        <div class="userInfo sec">
                            {{ selectedHistory.conversation.email }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.phone") }}
                        </div>
                        <div class="userInfo sec">
                            {{ selectedHistory.conversation.phone }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.subject") }}
                        </div>
                        <div class="userInfo sec">
                            {{ getTicketSubject(selectedHistory) }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.representative") }}
                        </div>
                        <div class="userInfo sec" v-if="type == 'ticket'">
                            {{ $_.get(selectedHistory, "conversation.assignedUser.name", "") || "" }}
                        </div>
                        <div class="userInfo sec" v-else>
                            {{ $_.get(selectedHistory, "conversation.user.name", "") || "" }}
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="userInfo">
                            <div class="userInfo first">
                                {{ $t("message.country") }}
                            </div>
                            <div class="userInfo sec">
                                {{ $_.get(selectedHistory, "conversation.visitor.country", "N/A") || "N/A" }}
                            </div>
                        </div>

                        <div class="userInfo pl-3">
                            <div class="userInfo first">
                                {{ $t("message.language") }}
                            </div>
                            <div class="userInfo sec">
                                {{ selectedHistory.conversation.languageCode }}
                            </div>
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.osAndBrowser") }}
                        </div>
                        <div class="userInfo sec">
                            {{ $_.get(selectedHistory, "conversation.visitor.os", "N/A") || "N/A" }}
                            {{ $_.get(selectedHistory, "conversation.visitor.browser", "N/A") || "N/A" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">IP</div>
                        <div class="userInfo sec">
                            {{ $_.get(selectedHistory, "conversation.visitor.ipAddress", "N/A") || "N/A" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.chatId") }}
                        </div>
                        <div class="userInfo sec">
                            {{ selectedHistory.conversation._id }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.customerClientVersion") }}
                        </div>
                        <div class="userInfo sec">
                            {{ $_.get(selectedHistory, "conversation.visitor.version.versionStr") || "3.5.0" }}
                        </div>
                    </div>
                </div>
                <div v-else class="bg-light border px-3 py-1 px-3 text-center mt-3">
                    {{ $t("message.noUserInfoFound") }}
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import moment from "moment";
import { Settings } from "luxon";
import { mapActions, mapState } from "vuex";
import Info from "./svg/Info";
import Representative from "./svg/Representative";
import SendIcon from "./svg/SendIcon";
import ChatId from "./svg/ChatId";
import Operating from "./svg/Operating";
import World from "./svg/World";
import Ip from "./svg/Ip";
import User from "./svg/User";
import Mail from "./svg/Mail";
import UserName from "./svg/UserName";
import KeywordShortCut from "./svg/KeywordShortCut";
import ConversationColor from "./svg/ConversationColor";
import MessageList from "./popup-chat/MessageList";
import * as _ from "lodash";
import { log2 } from "../utils/log2";
import AppBreadCrumb from "./common/AppBreadCrumb";
import { toNewMessagesModel } from "../utils/chat";
import Avatar from "vue-avatar";
import PassedTimeCounterTimeFormat from "./PassedTimeCounterTimeFormat";
import { i18n } from "../language";
import EmptyFilterResult from "../views/Pages/Chatbot/pages/archive/EmptyFilterResult.vue";

Settings.defaultLocale = i18n.locale;
const log = log2("ArchiveComponent");
const defaultStartDate = moment().startOf("day").toISOString();
const defaultEndDate = moment().endOf("day").toISOString();

export default {
    name: "ArchiveComponent",
    props: ["type", "tableData", "fetchCallback", "isArchive", "selectedTime", "hideFilters"],
    components: {
        User,
        Mail,
        Ip,
        World,
        Operating,
        ChatId,
        SendIcon,
        Representative,
        Info,
        KeywordShortCut,
        ConversationColor,
        MessageList,
        AppBreadCrumb,
        PassedTimeCounterTimeFormat,
        UserName,
        Avatar,
        EmptyFilterResult,
    },
    data() {
        return {
            // filters
            query: this.$route.query.query || null,
            selectedUser: this.$route.query.selectedUser || null,
            startDate: this.$route.query.allTime
                ? null
                : this.$route.query.startDate
                ? moment(parseInt(this.$route.query.startDate)).toISOString()
                : defaultStartDate,
            endDate: this.$route.query.allTime
                ? null
                : this.$route.query.endDate
                ? moment(parseInt(this.$route.query.endDate)).toISOString()
                : defaultEndDate,
            point: parseInt(this.$route.query.point) || undefined,
            page: 1,
            perPage: this.$route.query.perPage ? parseInt(this.$route.query.perPage) : 20,
            wideScreen: false,
            selectedHistory: {
                conversation: {},
                messages: [],
                id: undefined,
            },
            IsMessageInChat: false,
            timeSelect: this.$route.query.allTime ? "all-time" : "today",

            selectedCustomDateFilter: this.$route.query.allTime ? "all-time" : "today",
            rowIndex: 0,

            usersFilter: [],
            isBusy: false,
            fields: [
                {
                    key: "actions",
                    label: "",
                },
            ],
            maxDate: moment().toISOString(),
            lastFiveYear: moment().subtract(5, "year").toISOString(),
            lastPage: false,

            phrases: {
                ok: "Tamam",
                cancel: "Vazgeç",
            },
            isLoading: false,
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            cancels: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users,
            isAdmin: (state) => state.auth.adminUser != null,
            inputs: (state) =>
                state.customLoginForm.inputs.reduce((acc, cur) => {
                    acc[cur._id] = cur;
                    return acc;
                }, {}),
        }),
        filteredMessages() {
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
    },
    methods: {
        ...mapActions({
            getVisitors: "visitor/getVisitors",
            loadOldMessages: "chat/loadOldMessages",
            getUser: "user/getUser",
            getUsers: "user/getUsers",
        }),
        getTicketSubject(ticket) {
            const langContent = _.get(ticket, "conversation.subject.languageContent", []) || [];
            const langs = langContent.map((x) => x.languageCode);
            const validLang = langs.find((lang) => lang === this.$i18n.locale) || langs[0];
            if (validLang) {
                return (
                    _.get(
                        langContent.find((x) => x.languageCode === validLang),
                        "name",
                        "-"
                    ) || "-"
                );
            } else {
                const isChatbot = _.get(ticket, "conversation.conversation.startedWithChatBot", false) || false;
                if (isChatbot) {
                    return _.get(ticket, "subject", "-") || "-";
                } else {
                    return "-";
                }
            }
        },
        getCustomLoginInfos() {
            this.IsMessageInChat = false;
            let inputValues = this.selectedHistory.conversation.customLoginInfos || [];
            log.debug("getCustomLoginInfos called", {
                inputs: this.inputs,
                inputValues,
            });
            inputValues = inputValues
                .filter((v) => this.inputs[v.input])
                .map((v) => ({
                    value: v.value,
                    name: this.inputs[v.input].localizedLabel[this.$i18n.locale].text,
                }));
            return inputValues;
        },
        setCustomDateFilter(filter) {
            log("setCustomDateFilter ", filter);
            this.selectedCustomDateFilter = filter;
            if (filter === "today") {
                this.startDate = moment().startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "yesterday") {
                this.startDate = moment().subtract(1, "days").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "days").endOf("day").toISOString();
            } else if (filter === "current-week") {
                this.startDate = moment().startOf("week").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "last-week") {
                this.startDate = moment().startOf("isoWeeks").subtract(1, "days").startOf("isoWeeks").toISOString();
                this.endDate = moment().startOf("isoWeeks").subtract(1, "days").endOf("isoWeeks").toISOString();
            } else if (filter === "current-month") {
                this.startDate = moment().startOf("month").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "last-month") {
                this.startDate = moment().startOf("month").subtract(1, "days").startOf("month").toISOString();
                this.endDate = moment().startOf("month").subtract(1, "days").endOf("month").toISOString();
            } else if (filter === "last-30") {
                this.startDate = moment().subtract(30, "days").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "all-time") {
                this.startDate = null;
                this.endDate = null;
            }
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);

            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }
            log("allMessages", allMessages, this.typingMessage);
            return allMessages;
        },
        fetchAllUsers() {
            this.getUsers({ perPage: 1000, page: 1 }).then((response) => {
                log("getUsers completed", response.data);
                this.usersFilter = response.data;
            });
        },
        getUserHelper(userObjectOrUserId) {
            const isUserObject = typeof userObjectOrUserId === "object";
            const isUserId = typeof userObjectOrUserId === "string";
            if (isUserObject) {
                return userObjectOrUserId.name;
            } else if (isUserId) {
                let newUser = "-";
                const maybeUserObj = this.users.data.find((x) => x._id === userObjectOrUserId);
                if (maybeUserObj) {
                    newUser = maybeUserObj.name;
                }
                // log("getUserHelper", userObjectOrUserId, newUser, maybeUserObj);
                return newUser;
            } else {
                return "-";
            }
        },
        resetFilters() {
            this.$emit("resetFilters");
            this.startDate = defaultStartDate;
            this.endDate = defaultEndDate;
            this.query = null;
            this.selectedUser = null;
            this.point = undefined;
            this.getHistory(true);
        },
        getHistory(resetPage = false, customPage = undefined, customPerPage = undefined) {
            log.debug("getHistory", { resetPage, customPage, customPerPage });
            if (this.isBusy) {
                return;
            }
            if (resetPage) {
                this.page = 1;
                this.lastPage = false;
            } else if (this.lastPage) {
                return;
            }
            if (customPage) this.page = customPage;
            if (customPerPage) this.perPage = customPerPage;
            this.isBusy = true;
            this.IsMessageInChat = false;
            let currentCount = this.tableData.length;
            const startDate = new Date(this.startDate).getTime();
            const endDate = new Date(this.endDate).getTime();
            this.updateQueryParams("page", this.page);
            this.updateQueryParams("perPage", this.perPage);
            this.updateQueryParams("startDate", startDate ? startDate : null);
            this.updateQueryParams("endDate", endDate ? endDate : null);
            this.updateQueryParams("selectedUser", this.selectedUser);
            this.updateQueryParams("query", this.query);
            this.updateQueryParams("point", this.point ? this.point : null);
            this.updateQueryParams("allTime", this.selectedCustomDateFilter === "all-time" ? "1" : null);
            return (
                !!this.fetchCallback
                    ? this.fetchCallback({
                          perPage: this.perPage,
                          page: this.page,
                          startDate: this.startDate,
                          endDate: this.endDate,
                          query: this.query,
                          point: this.point,
                          userId: this.selectedUser,
                          infinityScroll: !resetPage,
                      })
                    : Promise.resolve()
            )
                .then()
                .finally(() => {
                    this.isBusy = false;
                    this.lastPage = currentCount === this.tableData.length;
                });
        },
        getOfflineMessages(message) {
            log("getOfflineMessages", message);
            const visitorMessage = {
                messageType: "visitor",
                createdDate: message.createdDate,
                message: _.get(message, "osrPayload.message"),
            };
            const userMessage = {
                messageType: "user",
                createdDate: message.resolvedDate,
                message: message.response,
                user: message.user,
            };
            let msgModel = toNewMessagesModel([visitorMessage, userMessage], this);
            return msgModel.filter((x) => x.data.text !== undefined);
        },
        view(id) {
            log("view", id, this.selectedHistory.id, this.selectedHistory);
            if (this.selectedHistory.id !== id) {
                // this.selectedHistory.messages = [];
                const maybeConversation = this.tableData.find((v) => v._id === id);
                if (maybeConversation) {
                    this.selectedHistory.conversation = maybeConversation;
                    this.selectedHistory.id = id;
                    const conversationId = _.get(maybeConversation, "conversation._id");
                    this.updateQueryParams("selectedChatId", id);
                    this.rowIndex = this.tableData.findIndex((v) => v._id === id);
                    const isChatbot =
                        _.get(this.selectedHistory, "conversation.conversation.startedWithChatBot", false) || false;
                    log("view debug", {
                        isChatbot,
                        isArchive: this.isArchive,
                        selectedHistory: this.selectedHistory,
                        maybeConversation,
                        conversationId,
                    });
                    if ((this.isArchive || isChatbot) && conversationId) {
                        this.selectedHistory.messages = [];
                        this.isLoading = true;
                        this.loadOldMessages(conversationId).then((response) => {
                            this.isLoading = false;
                            this.selectedHistory.messages = [
                                ...response.data.data,
                                {
                                    messageType: "user",
                                    createdDate: maybeConversation.responseDate,
                                    message: maybeConversation.response,
                                    user: maybeConversation.user,
                                    uniqMessageId: "user",
                                },
                            ];
                            log("view", this.selectedHistory);
                        });
                    } else {
                    }

                    setTimeout(() => {
                        const row = document.querySelector("tr.table-active");
                        if (row) {
                            document.getElementById("conversation-list").scrollTop = row.offsetTop;
                        }
                    }, 200);
                }
            }
            this.IsMessageInChat = true;
        },
        reset() {
            this.selectedHistory = {
                visitor: {},
                messages: [],
                id: undefined,
            };
        },
        rowClass(item, type) {
            if (item && type === "row") {
                if (this.selectedHistory.conversation._id === item._id) {
                    return "table-active";
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },
        handleScroll(event) {
            if (this.isBusy) {
                return;
            }
            if (event.target.scrollHeight - (event.target.scrollTop + event.target.clientHeight) < 100) {
                this.page += 1;
                this.getHistory(false);
            }
        },
        addMessage(data) {
            let mergeString = "";
            let lastDateM;
            let dateM;
            if (data.userId != undefined) {
                data.user = data.userId;
            }
            if (this.messages.length > 1) {
                lastDateM = moment(
                    String(
                        this.messages[this.messages.length - 1].date ||
                            this.messages[this.messages.length - 1].createdDate
                    )
                ).format("HH:mm");
                dateM = moment(String(data.date || data.createdDate)).format("HH:mm");

                if (data.visitor !== undefined && this.messages[this.messages.length - 1].visitor === data.visitor) {
                    mergeString = "\n";
                } else if (data.user !== undefined && this.messages[this.messages.length - 1].user === data.user) {
                    mergeString = "<br />";
                } else if (
                    data.visitorId !== undefined &&
                    this.messages[this.messages.length - 1].visitorId === data.visitorId
                ) {
                    mergeString = "\n";
                } else if (
                    data.userId !== undefined &&
                    this.messages[this.messages.length - 1].userId === data.userId
                ) {
                    mergeString = "<br />";
                }
            }

            if (
                mergeString !== "" &&
                lastDateM === dateM &&
                this.messages[this.messages.length - 1].messageType === data.messageType
            ) {
                const messageText = data.message || data.description;
                if (this.messages[this.messages.length - 1].message !== undefined) {
                    this.messages[this.messages.length - 1].message += mergeString + messageText;
                } else if (this.messages[this.messages.length - 1].description !== undefined) {
                    this.messages[this.messages.length - 1].description += mergeString + messageText;
                }
                this.emptyMessages.push("");
            } else {
                let isPush = true;
                let lastMessageSystemType = this.messages[this.messages.length - 1];
                if (
                    lastMessageSystemType != null &&
                    lastMessageSystemType.systemMessageType === "customer-online" &&
                    data.systemMessageType === "customer-offline"
                ) {
                    isPush = false;
                } else if (
                    lastMessageSystemType != null &&
                    lastMessageSystemType.systemMessageType === "customer-offline" &&
                    data.systemMessageType === "customer-online"
                ) {
                    isPush = false;
                }
                if (isPush) {
                    this.messages.push(data);
                } else {
                    this.messages[this.messages.length - 1].isHide = true;
                }
            }
        },
        queryChanged: _.debounce(function (newQuery, oldQuery) {
            log("queryChanged", { newQuery, oldQuery });
            if (newQuery !== oldQuery) {
                this.page = 1;
                this.getHistory(true);
            }
        }, 1000),
        updateQueryParams(key, value) {
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
        detectWideScreen() {
            let width = document.body.clientWidth;
            // log("resize comp çalıstı", { width });
            if (width < 1100) {
                this.wideScreen = false;
            } else {
                this.wideScreen = true;
            }
        },
    },
    mounted() {
        this.fetchAllUsers();
        const customPage = this.$route.query.page ? 1 : undefined;
        const customPerPage = this.$route.query.page ? parseInt(this.$route.query.page) * this.perPage : undefined;
        this.getHistory(false, customPage, customPerPage).then((x) => {
            if (this.$route.query.selectedChatId) {
                this.view(this.$route.query.selectedChatId);
            }
        });
        const keydownCallback = (e) => {
            if (e.key === "ArrowDown" && (e.ctrlKey || e.metaKey)) {
                const row = this.tableData[this.rowIndex + 1];
                if (row) {
                    this.view(row._id, this.rowIndex + 1);
                }

                /*document.getElementById("conversation-list").scrollTop = document.getElementById("conversation-list").scrollTop + 50;*/
                e.preventDefault();
            } else if (e.key === "ArrowUp" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex > 0) {
                    const row = this.tableData[this.rowIndex - 1];
                    if (row) this.view(row._id, this.rowIndex - 1);
                    /*document.getElementById("conversation-list").scrollTop = document.getElementById("conversation-list").scrollTop - 50;*/
                }
                e.preventDefault();
            }
        };
        window.addEventListener("keydown", keydownCallback);
        window.addEventListener("resize", this.detectWideScreen);
        this.detectWideScreen();

        this.cancels.push(() => {
            window.removeEventListener("keydown", keydownCallback);
            window.removeEventListener("resize", this.detectWideScreen);
        });
    },
    beforeDestroy() {
        this.reset();
        this.$router.replace({ query: null });
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        tableData() {
            if (!this.tableData.length) {
                this.IsMessageInChat = false;
            }
            if (this.tableData.length === 0) {
                this.selectedHistory = {
                    conversation: {},
                    messages: [],
                    id: undefined,
                };
            }
            if (this.tableData[0]) {
                const currentChatId = this.selectedHistory.conversation._id;
                const currentChatExists = this.tableData.find((v) => v._id === currentChatId);
                log("first view trigger 2", {
                    currentChatId,
                    currentChatExists,
                    tableData: this.tableData,
                });
                if (!currentChatExists) {
                    this.view(this.tableData[0]._id);
                }
            }
        },
        startDate(newValue, oldValue) {
            if (true || newValue) {
                log("startDate updated", newValue);
                this.page = 1;
                this.getHistory(true);
            }
        },
        endDate(newValue, oldValue) {
            if (true || newValue) {
                log("endDate updated", newValue);
                this.page = 1;
                this.getHistory(true);
            }
        },
        selectedUser(newValue, oldValue) {
            log("selectedUser updated", newValue);
            this.page = 1;
            this.getHistory(true);
        },
        query(newValue, oldValue) {
            log("query updated", newValue);
            this.queryChanged(newValue, oldValue);
            this.query = newValue;
        },
        point(newValue, oldValue) {
            log("query updated", newValue);
            this.point = newValue;
            this.getHistory(true);
        },
        visitors: {
            handler(newValue, oldValue) {
                log("visitors updated", newValue, this.selectedHistory);
                if (newValue && newValue.data) {
                    if (newValue.data.length > 0) {
                        const selectedChatIdFromParam = this.$route.query.selectedChatId;
                        log.debug("selectedChatIdFromParam", {
                            selectedChatIdFromParam,
                            exists: newValue.data.find((v) => v._id === selectedChatIdFromParam),
                        });
                        if (selectedChatIdFromParam && newValue.data.find((v) => v._id === selectedChatIdFromParam)) {
                            this.view(selectedChatIdFromParam);
                        } else {
                            const currentChatId = this.selectedHistory.conversation._id;
                            const currentChatExists = newValue.data.find((v) => v._id === currentChatId);
                            if (!currentChatExists) {
                                log("first view trigger 1", {
                                    currentChatId,
                                    currentChatExists,
                                    selectedChatIdFromParam,
                                    exists: newValue.data.find((v) => v._id === selectedChatIdFromParam),
                                });
                                this.view(newValue.data[0]._id);
                            }
                        }
                    }
                    if (newValue.data.length === 0) {
                        this.selectedHistory = {
                            conversation: {},
                            messages: [],
                            id: undefined,
                        };
                    }
                }
            },
            deep: true,
        },
        selectedTime(newVal) {
            this.timeSelect = newVal;
        },
        timeSelect(newVal) {
            if (newVal === "all-time") {
                this.endDate = null;
                this.startDate = null;
            }
            this.IsMessageInChat = false;
            this.setCustomDateFilter(newVal);
        },
    },
};
</script>

<style lang="scss">
.new-theme {
    $row-height: 80px;

    .userMetaInfo {
        position: absolute;
        top: 0;
        width: 100%;
        box-shadow: 0 0 3px #00000080;
        z-index: 9;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        transition: all 0.3s;
        transform: translateY(calc(-100% + 40px));

        &:hover {
            top: 0;
            transform: translateY(0);

            .md-icon.text-info {
                transition: all 0.3s;
                transform: rotateZ(180deg);
            }
        }
    }

    .info {
        .custom-card {
            display: flex;
            flex-direction: column;
            padding: 10px 20px;
        }

        span {
            font-family: Poppins;
            font-weight: 300;
            color: #181c32;
            font-size: 12px;
            margin-bottom: 0;
            width: 90px;
            display: block;
        }

        b,
        b span {
            display: block;
            font-family: Poppins;
            font-weight: 500;
            color: #181c32;
            font-size: 12px;
            white-space: nowrap;
        }
    }

    .info {
        position: relative;
        height: $row-height;
        transition: all 0.3s;
        cursor: pointer;
        display: flex;

        .custom-card {
            width: 100%;
            height: 100%;
            border-radius: 0;
        }

        .back {
        }
    }

    #time-select {
        border: none;
        background-color: #f3f6f9;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 12px;
        font-family: Poppins;
        font-weight: bolder;
        color: #3699ff;
    }

    .b-table {
        border-radius: 6px;
        box-shadow: none;
        margin-bottom: 0;

        thead {
            display: none;
        }

        tr {
            box-shadow: none !important;
            height: $row-height !important;
            padding: 0 !important;
            border-bottom: 1px solid #ebedf3;

            &.table-active {
                background-color: #515173;

                b,
                span {
                    color: #eef0f8;
                }
            }
        }

        td {
            padding: 0 !important;
            vertical-align: top !important;
            overflow: hidden;
        }
    }

    .row.custom-row {
        margin: 0 15px;

        div[class^="col"] {
            padding: 0;
        }
    }

    .scrollable {
        position: relative;
        overflow-y: scroll;
        height: calc(100vh - 180px);
        min-height: 70vh;
        border-radius: 8px;
        border: 1px solid var(--color-border-default);
    }

    .custom-input input,
    .custom-input ul,
    .custom-input select {
        background-color: #ffffff;
        border: none;
        border-radius: 6px !important;
        height: 30px;
    }

    .custom-input ul {
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #information-list2 {
        box-shadow: 0 0 3px #00000080;
        z-index: 9;
        background-color: #ffffff;
        padding: 20px;
        margin-bottom: 0px;
        border-radius: 6px;
        overflow-y: auto;
    }

    .headtitle {
        font-size: 18px;
        color: #101217;
        /*   padding-bottom: 5px;*/
    }

    .userInfo {
        font-family: Poppins;

        &.first {
            color: #3699ff;
            font-size: 16px;
            font-weight: 500;
            padding-top: 15px;
        }

        &.sec {
            color: #181c32;
            font-size: 14px;
            font-weight: 300;
            padding-top: 2px;
        }
    }
}

.dark-mode {
    input::placeholder {
        color: #ffffff !important;
    }
}
</style>
